import { render, staticRenderFns } from "./ViewTeams.vue?vue&type=template&id=02065a3b&scoped=true"
import script from "./ViewTeams.vue?vue&type=script&lang=js"
export * from "./ViewTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02065a3b",
  null
  
)

export default component.exports